import React from 'react'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import graphqlQuery from 'graphs/queries/Feature.graphql'

const FeatureProvider = ({ children, ...rest }) => (
  <Query query={graphqlQuery} {...rest}>
    {({ loading, data: { feature } }) => (
      <Broadcast channel="feature" value={{ loading, feature }}>
        {children}
      </Broadcast>
    )}
  </Query>
)

export default FeatureProvider



// WEBPACK FOOTER //
// ./src/components/Feature/Provider.js